import React from 'react';
import TopQuestion from '../../utils/question/topQuestion';
import { connect } from 'react-redux';
import WordCloud from '../../utils/question/wordCloud';

const mapStateToProps = (state) => {
	const {
		rightSectionProps,
		questionNo,
		isMicPermitted,
	} = state.rootReducer.testPageDetails;

	return {
		rightSectionProps,
		questionNo,
		isMicPermitted,
	};
};
const ClozePassage = ({
	rightSectionProps,
	rightSectionProps: { clozeQuestion, question, prompt, resetCounter },
	isMicPermitted,
	questionNo,
	setResetCounter,
}) => {
	return (
		<section className="que-container ">
			<section className="quiz-page-content">
				<TopQuestion />
				<p
					style={{ display: 'none' }}
					className="error test_validation"
					id="errorWordcloudPage"
				>
					Please answer the question
				</p>
				<section className="quiz-area-options">
					<h6>{prompt}</h6>
					<WordCloud />
				</section>
			</section>
		</section>
	);
};

export default connect(mapStateToProps)(ClozePassage);
